import React from "react"
import { countryCurrency } from "@app/types"

type Product = {
  name: string
  price: number
  imageUrl: string
  url: string
  msrp?: number
  ss_id?: string
}

type Props = {
  product?: Product | null
  currentCountryCurrency?: countryCurrency
}

export function CompactProductCard({ product, currentCountryCurrency }: Props) {
  if (!product) return null

  return (
    <div className="product-card-compact--container">
      <div className="product-card-compact--image-container">
        {product.imageUrl ? (
          <img src={product.imageUrl} alt={product.name || "product image"} />
        ) : null}
      </div>
      <div className="product-card-compact--details">
        <div className="product-card-compact--main-detail-container">
          <p className="product-card-compact--title">
            {product.name ? product.name.toLowerCase() : ""}
          </p>
          <p className="product-card-compact--price">
            {currentCountryCurrency?.currencySymbol}
            {product?.price}
          </p>
        </div>

        {product.url ? (
          <a className="product-card-compact--link" href={product.url}>
            View Product{" "}
            <span className="product-card-compact--underline"></span>
          </a>
        ) : null}
      </div>
    </div>
  )
}
